import { render } from "./holly.vue?vue&type=template&id=2142d280&scoped=true"
import script from "./holly.vue?vue&type=script&lang=js"
export * from "./holly.vue?vue&type=script&lang=js"

import "./holly.vue?vue&type=style&index=0&id=2142d280&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2142d280"]])

export default __exports__